import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import React from "react";
import {useTranslation} from "react-i18next";
import {TextStyle, TitleStyle} from "../../../../../../../../layouts/styles";
import { Colors } from "../../../../../../../../components/theme";

const TechnicalInfo = ({dataSet}) => {
    const {t} = useTranslation();

    const fieldView = (fieldName) => {
        if (fieldName === 'direction' && dataSet[fieldName] === 'None') return t("common.titles.to_define")
        return dataSet[fieldName] ? dataSet[fieldName] : t("common.titles.to_define")
    }

    const solistes = dataSet.solistes.map(sol => (
        <span key={sol.pk}>
            {`${sol.cn__first_name} ${sol.cn__last_name} (${sol.comment})`}
            <br/>
        </span>
    ));

    return (<>
        <RedHeader title={t('project.techInfo_title')}/>
        <div className="row mx-2 py-4" style={{borderBottom:`1px solid ${Colors.darkGray}`}}>
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.direction_title")}
                </p>
                <p style={TextStyle}>
                    {fieldView("direction")}
                </p>
            </div>
            {/*COOPERATION WITH*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.in_coop_title")}
                </p>
                <p style={TextStyle}>
                    {dataSet.cooperation_with.length > 0
                        ? dataSet.cooperation_with.map((item, index) => (
                                <span key={index}>
                                    {index + 1}. {item[0]}
                                    <br/>
                                </span>
                            ))
                        : t("common.titles.to_define")}
                </p>
             </div>
            {/*SOLISTES*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.soloists_title")}
                </p>
                <p style={TextStyle}>
                    {dataSet.solistes.length > 0 ? solistes : t("common.titles.to_define")}
                </p>
            </div>
        </div>
        
        <div className="row mx-2 py-4" style={{borderBottom:`1px solid ${Colors.darkGray}`}}>
            {/*CONCERT MASTER*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.kzm_title")}
                </p>
                <p style={TextStyle}>
                    {fieldView("concertmaster")}
                </p>
            </div>

            {/*DRESS CODE*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.dreeCode_title")}
                </p>
                <p style={TextStyle}>
                    {fieldView("dress_code")}
                </p>
            </div>

            {/*ABOUT PUPITRE*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.pupitre_title")}
                </p>
                <p style={TextStyle}>
                    {fieldView("aboutPupitre")}
                </p>
            </div>
        </div>

        
        <div className="row mx-2 py-4">
            {/*PROGRAM*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.program_title")}
                </p>
                <p style={TextStyle}>
                    {fieldView("program")}
                </p>
            </div>

            {/*COMMENT*/}
            <div className="col-xs-6 col-sm-4">
                <p style={TitleStyle}>
                    {t("project.tech_info.comment_title")}
                </p>
                <p style={TextStyle}>
                    {fieldView("comment")}
                </p>
            </div>
        </div>
    </>)
}

export default TechnicalInfo
